var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9.1 16.7",
    style: {
      enableBackground: "new 0 0 9.1 16.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6,11.5l-1-3.2l-1,3.2H0.2l2.7,2l-1,3.2l2.7-2l2.7,2l-1-3.2l2.7-2L5.6,11.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.9,7.7 3.9,0 0,0 0,5.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.1,5.9 9.1,0 5.2,0 5.2,7.7  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.cd0db05127001a0fac210f7c9da29779.svg";
export { ForwardRef as ReactComponent };